import { render, staticRenderFns } from "./Projects_figuration.vue?vue&type=template&id=7df05e38&"
import script from "./Projects_figuration.vue?vue&type=script&lang=js&"
export * from "./Projects_figuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports